<template>
  <el-drawer :visible="visible" 
  size="1150px" 
  :show-close="false" 
  :before-close="handleDrawerBeforeClose" 
  custom-class="inventory-detail-drawer" @close="close">
    <div class="inventory-detail-wrap">
      <el-container style="height:100%;" direction="vertical">
        <el-header height="40px;">
          <span class="span-spec-name">盘点日期：{{ calcTotalCount('time') }}</span>
          <span class="span-spec-count" v-if="$store.state.routes.systemSetting.MultiWarehouse">
            仓库：
            <template v-if="checkRight('check')">
              <warehouse-select
                :value.sync="detail.row.WID"
                select_style="width:150px;"
                :set_default="true"
                @handleChanged="handleWarehouseUpdated"
              />
            </template>
            <template v-else>
              {{ detail.row.WName ? detail.row.WName : '默认仓库' }}
            </template>
          </span>
          <span class="span-spec-count">盘点前合计：{{ calcTotalCount('OldStock') }}</span>
          <span class="span-spec-count">盘点后合计：{{ calcTotalCount('NewStock') }}</span>
          <span class="span-spec-count">盈亏合计：{{ calcTotalCount('AddStock') }}</span>
          <span class="header-close" @click="handleCloseClick"><i class="el-icon-close"></i></span>
        </el-header>
        <el-main>
          <el-table
            ref="detailTable"
            :data="detail.rowDetails"
            v-loading="detail.loading"
            border
            :header-cell-style="{
              'background-color': '#E5EEF6',
              'border-color': 'rgba(218, 223, 228, 1)',
              height: '48px',
            }"
            height="100%"
          >
            <el-table-column label="序号" width="80px" align="center">
              <template slot-scope="{ row, $index }">
                <template v-if="row._NewRow && checkRight('newDetail')">
                  <el-button type="text" @mousedown.native.prevent @click="addNewDetails(row)">新增</el-button>
                </template>
                <template v-else>
                  {{ checkRight('newDetail') ? $index : $index + 1 }}
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="ItemNo" label="货号" header-align="center" align="center" width="235" :resizable="false">
              <template slot-scope="{ row, $index }">
                <template v-if="row._NewRow && checkRight('newDetail')">
                  <el-autocomplete
                    placeholder="请输入货号"
                    v-model="row.ItemNo"
                    :trigger-on-focus="false"
                    value-key="ItemNo"
                    :fetch-suggestions="querySearchItemNo"
                    @change="handleMatchItemNo(row)"
                    :clearable="true"
                    @select="handleSeletedItemNo($event, row)"
                    style="width: 95%"
                  ></el-autocomplete>
                </template>
                <template v-else>
                  {{ row.ItemNo }}
                  <span v-if="checkRight('copy')" class="span-copy" @click="handleCopyDetail(row)">复制</span>
                  <span v-if="checkRight('deleteDetail')" class="span-delete" @click="deleteDetail($index)">删除</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="SpecName" label="颜色及规格" header-align="center" align="center" width="200" :resizable="false">
              <template slot-scope="{ row }">
                <template v-if="row._NewRow && checkRight('newDetail')">
                  <el-select v-model="row.SpecID" style="width: 90%" placeholder="请选择规格" :clearable="true">
                    <el-option
                      v-for="(newItem, index) in newDetails"
                      :key="index"
                      :value="newItem.SpecID"
                      :label="newItem.SpecName"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else>
                  {{ row.SpecName }}
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="OldStock" label="盘点前库存" header-align="center" align="center" width="200" :resizable="false">
              <template slot-scope="{ row }">
                <template v-if="row._NewRow && checkRight('newDetail')">-</template>
                <template v-else>
                  {{ row.OldStock }}
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="NewStock" label="盘点后库存" header-align="center" align="center" width="200" :resizable="false">
              <template slot="header">
                <span style="line-height: 30px">盘点后库存</span>
                <el-button type="primary" v-if="checkRight('newDetail')" @click="batchSetNum" style="float: right"> 盘前库存 </el-button>
              </template>
              <template slot-scope="{ row,$index }">
                <template v-if="row._NewRow && checkRight('newDetail')">
                  <el-input-number
                    style="width: 80px"
                    :controls="false"
                    :min="0"
                    v-model="row.NewStock"
                    :ref="'stock' + $index"
                    @focus="handleSelectText($event)"
                    @change="detail.isUpdate = true"
                  ></el-input-number>
                </template>
                <template v-else>
                  <template v-if="checkRight('editDetailStock')">
                    <el-input-number
                      style="width: 80px"
                      :controls="false"
                      :min="0"
                      v-model="row.NewStock"
                      :ref="'stock' + $index"
                      @focus="handleSelectText($event)"
                      @change="detail.isUpdate = true"
                    ></el-input-number>
                  </template>
                  <template v-else>
                    {{ row.NewStock }}
                  </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="AddStockStr" label="盈亏库存" header-align="center" align="center" width="180" :resizable="false">
              <template slot-scope="{ row }">
                <template v-if="row._NewRow && checkRight('newDetail')">-</template>
                <template v-else>
                  {{ calcDetail(row) }}
                </template>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
        <el-footer height="40px" style="line-height: 40px;">
          <div>
            <el-button type="danger" v-if="checkRight('delete')" @click="deleteRow" :loading="deleteLoading"> 删除盘点单 </el-button>
            <el-button type="success" v-if="checkRight('save')" @click="handleSave('save')" :loading="saveLoading"> 保存 </el-button>
            <el-button type="primary" v-if="checkRight('check')" @click="handleSave('check')" :loading="checkLoading"> 确认生效 </el-button>
            <el-button type="primary" v-if="checkRight('newDetail')" @click="showAddGoodDlg()">新增盘点商品</el-button>
          </div>
          <div>
            <el-upload
              ref="uploadXls"
              accept=".xls,.xlxs"
              :action="xlsData.uploadUrl + '?InventoryID=' + (detail.row == null ? 0 : detail.row.InventoryID)"
              :show-file-list="false"
              class="div-upload"
              :headers="xlsData.headers"
              :on-success="uploadXlsSuccess"
              :multiple="false"
              :on-error="uploadXlsError"
              :before-upload="uploadXlsBefore"
              v-if="checkRight('import')"
            >
              <el-button type="default" plain>导入盘点后库存</el-button>
            </el-upload>
            <el-button type="default" v-if="checkRight('export')" @click="handleExport">导出盘点单</el-button>
            <el-button type="default" v-if="checkRight('print')" @click="handlePrint">打印盘点单</el-button>
          </div>
        </el-footer>
      </el-container>
    </div>
    <add-goods ref="addGoodsDlg" @handleSave="handleAddGoods"></add-goods>
    <div id="print-view">
      <div class="print-view-main">
        <div class="paper-wrapper paper-a4"></div>
      </div>
      <trade-print ref="tradePrint" :print-view-tab.sync="print.type" :print-config.sync="print.config"></trade-print>
    </div>
  </el-drawer>
</template>

<script>
import { submit, exportFile } from '@/api/base'
import { baseURL, successCode } from '@/config'
import dayjs from 'dayjs'
import AddGoods from '@/views/wms/stock/components/AddGoods.vue'
import TradePrint from '@/views/stall/trade/components/TradePrint.vue'
import WarehouseSelect from '@/views/components/common/WarehouseSelect.vue'
export default {
  name: 'InventoryDetail',
  components: { AddGoods, TradePrint, WarehouseSelect },
  data() {
    return {
      visible: false,
      printInited: false,
      detail: {
        loading: false,
        isUpdate: false,
        row: {
          InventoryID: 0,
          WID: 0,
          CheckFlag: 0,
        },
        rowDetails: [],
      },
      deleteLoading: false,
      saveLoading: false,
      checkLoading: false,
      timeout: null,
      searchItems: [],
      newDetails: [],
      xlsData: {
        loading: null,
        uploadUrl: `${baseURL}/api/wms/inventory/importInventoryDetail`,
        headers: {
          Authorization: 'Bearer ' + this.$store.getters['user/accessToken'],
        },
      },
      print: {
        type: 'a4',
        config: {
          a4: {
            printType: 3,
            title: '',
            itemNoWidth: 80,
            colorWidth: 50,
            showSettlePrice: false,
            orderBySkuCountForPrint: true,
            fontSize: {
              name: 15,
              detail: 14,
              statistics: 15,
              price: 14,
            },
          },
        },
      },
    }
  },
  methods: {
    close() {
      this.visible = false
      // 打开过具体单据（含导入成功打开）后关闭，刷新列表；保存成功已刷且已被清空不重复刷
      if (this.detail.row != null && this.detail.row.InventoryID > 0) {
        this.$emit('refresh')
      }
    },
    handleCloseClick() {
      this.handleDrawerBeforeClose(() => {
        this.visible = false
      })
    },
    reset() {
      this.removeEditData()
      this.visible = false
    },
    handleDrawerBeforeClose(done) {
      if (this.detail.isUpdate) {
        this.$confirm(`当前盘点单存在变动尚未保存，点击确定将丢失变动过的数据，是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.removeEditData()
            this.$emit('refresh')
            done()
          })
          .catch(() => {
            //取消
          })
      } else {
        done()
      }
    },
    open(row) {
      this.load(row)
    },
    add() {
      if (this.detail.isUpdate) {
        this.$confirm(`当前盘点单存在变动尚未保存，是否继续创建新的盘点单?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.removeEditData()
            this.detail.isUpdate = true
            this.visible = true
            this.$nextTick(() => {
              this.showAddGoodDlg()
            })
          })
          .catch(() => {
            //取消
          })
      } else {
        this.removeEditData()
        this.visible = true
        this.$nextTick(() => {
          this.showAddGoodDlg()
        })
      }
    },
    async handleWarehouseUpdated() {
      if (typeof this.detail.row.WID != 'undefined' && this.detail.row.WID > 0) {
        var specIds = []
        this.detail.rowDetails.forEach(d => {
          if (typeof d.SpecID != 'undefined' && d.SpecID > 0) {
            specIds.push(d.SpecID)
          }
        })
        if (specIds.length > 0) {
          this.detail.loading = true
          const { data } = await submit('/api/wms/allocate/getProductSpecStock', {
            WID: this.detail.row.WID,
            SpecIDs: specIds,
          })
          this.detail.rowDetails.forEach(d => {
            let stock = 0
            if (typeof data[d.SpecID] != 'undefined') {
              stock = data[d.SpecID]
            }
            d.OldStock = stock
          })
          this.detail.loading = false
        }
      }
      
      // 只有打开/编辑已有单据时切仓库才算变动；
      if (this.detail.row != null && this.detail.row.length > 0  && this.detail.row.InventoryID > 0) {
        this.detail.isUpdate = true
      }
    },
    async handleCopyDetail(row) {
      this.detail.loading = true
      const { data } = await submit('/api/purchase/getProducts', {
        Keyword: row.ItemNo,
        GetSpecs: true,
        GetStock: true,
        FuzzySearch: false,
        WIDs: this.detail.row.WID,
      })
      this.searchItems = data
      if (this.searchItems.length > 0) {
        this.detail.rowDetails[0].SpecName = row.SpecName
        this.detail.rowDetails[0].ProductID = row.ProductID
        this.detail.rowDetails[0].ItemNo = row.ItemNo
        this.handleMatchItemNo(this.detail.rowDetails[0])
      }
      this.detail.loading = false
      this.detail.isUpdate = true
    },
    addNewDetails(row) {
      if (row.ProductID <= 0) {
        this.$message({ type: 'error', message: '请选择商品' })
        return
      }
      for (var i = 0; i < this.newDetails.length; i++) {
        var item = this.newDetails[i]
        if (row.SpecID && row.SpecID > 0 && item.SpecID != row.SpecID) {
          continue
        }
        if (this.detail.rowDetails.some(x => typeof x._NewRow == 'undefined' && x.ProductID == item.ProductID && x.SpecID == item.SpecID)) {
          continue
        }
        var mainId = this.detail.row == null ? 0 : this.detail.row.InventoryID
        this.detail.rowDetails.push({
          IDetailID: 0,
          InventoryID: mainId,
          ProductID: item.ProductID,
          SpecID: item.SpecID,
          SpecName: item.SpecName,
          ItemNo: row.ItemNo,
          OldStock: item.Stock,
          NewStock: row.NewStock,
          AddStock: (row.NewStock == null ? 0 : row.NewStock) - item.Stock,
        })
      }
      this.setRowDetails(this.detail.rowDetails)
      this.detail.isUpdate = true
    },
    async querySearchItemNo(query, callback) {
      if (query !== '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(async () => {
          const { data } = await submit('/api/purchase/getProducts', {
            Keyword: query,
            GetSpecs: true,
            GetStock: true,
            WIDs: this.detail.row.WID,
          })
          this.searchItems = data
          if (callback != null) {
            callback(data)
          }
        }, 200)
      }
    },
    handleSeletedItemNo(selectedRow, row) {
      var specs = selectedRow.Specs
      this.newDetails = specs
      row.ProductID = selectedRow.ProductID
      row.ItemNo = selectedRow.ItemNo
    },
    handleMatchItemNo(row) {
      let selectedRow = this.searchItems.filter(i => i.ItemNo.toLowerCase() == row.ItemNo.toLowerCase())
      if (typeof row._NewRow != 'undefined' && row._NewRow) {
        row.SpecID = undefined
        row.SpecName = ''
      }
      if (selectedRow.length > 0) {
        this.handleSeletedItemNo(selectedRow[0], row)
      } else {
        this.newDetails = []
      }
    },
    handleSelectText(e) {
      e.currentTarget.select()
    },
    checkRight(type) {
      switch (type) {
        case 'export':
          return this.detail.row != null
        case 'print':
          return this.detail.row != null && this.detail.row.CheckFlag == 1
        case 'import':
        case 'check':
          return this.detail.row != null && this.detail.row.CheckFlag == 0
        case 'delete':
          return this.detail.row != null && this.detail.row.CheckFlag == 0 && this.detail.row.InventoryID != 0
        case 'save':
        case 'editDetailStock':
        case 'copy':
        case 'deleteDetail':
        case 'newDetail':
          return this.detail.row == null || (this.detail.row != null && this.detail.row.CheckFlag == 0)
      }
    },
    deleteDetail(index) {
      this.detail.rowDetails.splice(index, 1)
      this.detail.isUpdate = true
    },
    deleteRow() {
      if (this.detail.row == null || this.detail.row.InventoryID == 0) {
        return
      }
      this.$confirm(`您是否要删除当前盘点单?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.deleteLoading = true
          const result = await submit(`/api/wms/inventory/delete`, { InventoryIDs: this.detail.row.InventoryID })
          this.deleteLoading = false
          if (result.success) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.removeEditData()
            this.$emit('refresh')
          }
        })
        .catch(() => {
          //取消
        })
    },
    calcDetail(row) {
      var addStock = (row.NewStock == null ? 0 : row.NewStock) - row.OldStock
      if (addStock > 0) {
        return '盘盈+' + addStock
      } else if (addStock < 0) {
        return '盘亏' + addStock
      } else {
        return '0'
      }
    },
    calcTotalCount(type) {
      if (type == 'time') {
        return this.detail.row == null || this.detail.row.InventoryID == 0 ? '新建' : this.detail.row.RecordAddTime
      } else {
        var count = 0
        for (var x = 0; x < this.detail.rowDetails.length; x++) {
          if (this.detail.rowDetails[x]._NewRow) continue
          var typeValue = this.detail.rowDetails[x][type]
          count += typeValue == null ? 0 : typeValue
        }
        return count
      }
    },
    showAddGoodDlg() {
      this.$refs.addGoodsDlg.init(true, '新增盘点商品')
    },
    handleAddGoods(data) {
      var mainId = this.detail.row == null ? 0 : this.detail.row.InventoryID
      for (var color in data.Colors) {
        for (var i = 0; i < data.Colors[color].Details.length; i++) {
          var sizeDetail = data.Colors[color].Details[i]
          var has = this.detail.rowDetails.some(
            x => typeof x._NewRow == 'undefined' && x.ProductID == sizeDetail.ProductID && x.SpecID == sizeDetail.SpecID
          )
          if (!has) {
            this.detail.rowDetails.push({
              IDetailID: 0,
              InventoryID: mainId,
              ProductID: data.ProductID,
              SpecID: sizeDetail.SpecID,
              SpecName: color + '-' + sizeDetail.Size,
              ItemNo: data.ItemNo,
              OldStock: sizeDetail.Stock,
              NewStock: undefined,
              AddStock: 0 - sizeDetail.Stock,
            })
          }
        }
      }
      this.setRowDetails(this.detail.rowDetails)
      this.detail.isUpdate = true
    },
    batchSetNum() {
      for (var i = 0; i < this.detail.rowDetails.length; i++) {
        if (this.detail.rowDetails[i]._NewRow) continue
        this.detail.rowDetails[i].NewStock = this.detail.rowDetails[i].OldStock
        this.detail.rowDetails[i].AddStock = 0
      }
      this.detail.isUpdate = true
    },
    removeEditData() {
      this.detail.row = {
        InventoryID: 0,
        WID: 0,
        CheckFlag: 0,
      }
      this.setRowDetails([])
      this.detail.isUpdate = false
    },
    async load(row) {
      this.detail.loading = true
      this.detail.isUpdate = false // 打开新单据时重置未保存标记
      this.detail.row = JSON.parse(JSON.stringify(row))
      this.detail.row.Details = []
      const result = await submit('/api/wms/inventory/getDetails', { InventoryID: row.InventoryID })
      if (result.success) {
        this.detail.row.Details = result.data
      }
      this.setRowDetails(this.detail.row.Details)
      this.detail.loading = false
      this.visible = true
      this.$nextTick(() => {
        if (!this.printInited && this.$refs.tradePrint) {
          this.$refs.tradePrint.init()
          this.printInited = true
        }
      })
    },
    setRowDetails(list) {
      if (list && list.length > 0) {
        list = list.filter(x => x._NewRow == undefined || x._NewRow != true)
        list = list.sort(function (a, b) {
          if (a.ProductID !== b.ProductID) return a.ProductID < b.ProductID ? -1 : 1
          else if (a.SpecName !== b.SpecName) return a.SpecName < b.SpecName ? -1 : 1
        })
      }
      this.newDetails = []
      if (this.detail.row != null && this.detail.row.CheckFlag == 1) {
        this.detail.rowDetails = list
      } else {
        var newRow = {
          _NewRow: true,
          ProductID: 0,
          SpecID: undefined,
          SpecName: '',
          ItemNo: '',
          OldStock: 0,
          NewStock: undefined,
          AddStock: 0,
        }
        if (list && list.length > 0) {
          this.detail.rowDetails = [newRow, ...list]
        } else {
          this.detail.rowDetails = [newRow]
        }
      }
    },
    async handleSubmit(type) {
      var param = {
        InventoryID: this.detail.row == null ? 0 : this.detail.row.InventoryID,
        WID: this.detail.row == null ? 0 : this.detail.row.WID,
        Type: type,
        Details: [],
      }
      for (var i = 0; i < this.detail.rowDetails.length; i++) {
        var item = this.detail.rowDetails[i]
        if (typeof item._NewRow != 'undefined' && item._NewRow) continue
        param.Details.push({
          ProductID: item.ProductID,
          SpecID: item.SpecID,
          NewStock: item.NewStock,
        })
      }
      if (param.Type == 'save') {
        this.saveLoading = true
      } else {
        this.checkLoading = true
      }
      const result = await submit(`/api/wms/inventory/save`, param).catch(error => {
        if (param.Type == 'save') {
          this.saveLoading = false
        } else {
          this.checkLoading = false
        }
      })
      if (param.Type == 'save') {
        this.saveLoading = false
      } else {
        this.checkLoading = false
      }
      if (result.success) {
        this.$message({
          type: 'success',
          message: '操作成功!',
        })
        this.removeEditData()
        this.visible = false
        this.$emit('refresh', result.data, param.InventoryID > 0)
      }
    },
    async handleSave(type) {
      var details = this.detail.rowDetails.filter(x => x._NewRow == undefined || x._NewRow != true)
      if (details.length <= 0) {
        this.$message({ type: 'error', message: '请先添加要盘点的商品' })
        return
      }
      var emptyIdx = this.detail.rowDetails.findIndex(x => x._NewRow != true && x.NewStock == null)
      if (emptyIdx >= 0) {
        this.$message({ type: 'error', message: `盘点后商品库存不能为空` })
        this.$nextTick(() => {
          var input = this.$refs['stock' + emptyIdx]
          if (input) input.focus()
        })
        return
      }
      if (type == 'save') {
        this.handleSubmit(type)
      } else {
        this.$confirm('确认提交生效当前盘点单?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(async () => {
            this.handleSubmit(type)
          })
          .catch(() => {
            //取消
          })
      }
    },
    async handleExport() {
      const today = dayjs(this.detail.row.RecordAddTime).format('YYYYMMDDHHmmss')
      var excelName = (this.detail.row.CheckFlag == 1 ? '' : '【未审】') + '盘点单_' + '_' + today + '.xls'
      await this.baseExport(excelName, '/api/wms/inventory/export', {
        InventoryID: this.detail.row.InventoryID,
      })
    },
    async baseExport(excelName, url, param) {
      const { data } = await exportFile(url, param)
      const blob = new Blob([data.Blob], { type: 'application/vnd.ms-excel' })
      var a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = excelName
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    uploadXlsSuccess(res) {
      if (successCode.includes(res.code)) {
        this.$message({ type: 'success', message: res.msg })
      } else {
        this.$message({ type: 'error', message: '导入错误：' + res.msg })
      }
      this.$refs.uploadXls.clearFiles()
      if (this.xlsData.loading != null) {
        this.xlsData.loading.close()
      }
      this.xlsData.loading = null
      this.$emit('refresh', res.data, true)
    },
    uploadXlsError() {
      // 取消确认框（未开始上传，loading 未设置）时不视为导入失败
      if (this.xlsData.loading == null) {
        return
      }
      this.$message({ type: 'error', message: '导入失败' })
      if (this.xlsData.loading != null) {
        this.xlsData.loading.close()
      }
      this.xlsData.loading = null
    },
    uploadXlsBefore(file) {
      // 待生效（待确认）单导入前提示确认
      if (this.detail.row != null && this.detail.row.CheckFlag == 0) {
        return this.$confirm(`当前盘点单存在未保存的变更，导入后将丢失这些变更数据，是否继续导入?`, '未保存的变更', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.xlsData.loading = this.$loading({
              lock: true,
              text: '正在导入中......',
            })
          })
          .catch(() => {
            return Promise.reject('cancel')
          })
      }
      this.xlsData.loading = this.$loading({
        lock: true,
        text: '正在导入中......',
      })
    },
    async handlePrint() {
      var inventoryID = this.detail.row.InventoryID
      const today = dayjs(this.detail.row.RecordAddTime).format('YYYYMMDDHHmmss')
      await this.$refs.tradePrint.getInventoryPrintInfo(inventoryID)
      if (this.$refs.tradePrint.printData.length > 0) {
        await this.$refs.tradePrint.printInventory()
        this.$('#print-view .paper-bill,#print-view .paper-tag').empty()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .inventory-detail-drawer .el-drawer__body {
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin: 4px 8px;
  }

  .inventory-detail-drawer .el-table th.el-table__cell {
    background-color: #e5eef6;
    height: 48px;
    font-weight: bold;
    color: #333;
    text-align: center;
  }

  .el-header {
    line-height:40px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    .span-spec-name {
      font-weight: bold;
      font-size: 20px;
    }

    .span-spec-count {
      margin-left: 20px;
      font-size: 16px;
    }
    .header-close {
      margin-left: auto;
      font-size: 20px;
      line-height: 40px;
      color: #909399;
      cursor: pointer;
    }
  }

  .el-drawer__header {
    display: none;
  }

  .el-main {
    .size-tag {
      height: 36px;
      line-height: 33px;
      margin: 6px 5px 3px 0px;
      float: left;

      .el-input--small .el-input__inner {
        height: 22px;
        line-height: 22px;
        padding: 0px;
        text-align: center;
      }
    }

    .tag-item:hover .icon-delete {
      display: block;
    }

    .span-delete {
      color: red;
      font-size: 12px;
      cursor: pointer;
      margin-left: 5px;
    }

    .span-copy {
      color: green;
      font-size: 12px;
      cursor: pointer;
      margin-left: 5px;
    }

    .span-delete:hover {
      text-decoration: underline;
    }

    .icon-delete {
      background-color: red;
      border-radius: 10px;
      color: #fff;
      opacity: 0.8;
      float: left;
      cursor: pointer;
      display: none;
      margin-left: -15px;
    }
  }

  .el-footer {
    .el-button {
      height: 30px;
    }

    & > div {
      display: inline-block;
      width: 60%;

      &:last-child {
        text-align: right;
        width: 40%;

        .div-upload,
        .el-button {
          display: inline-block;
          margin-left: 5px;
        }
      }
    }
  }
}

.inventory-detail-wrap {
  flex: 1;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#print-view {
  position: fixed;
  left: -1000px;
}
</style>
